import { useCallback, useState } from "react";

export const useFocusManagement = () => {
    const [isFocused, setIsFocused] = useState(false);
    
    const handleFocus = useCallback(() => setIsFocused(true), []);
    const handleBlur = useCallback(() => setIsFocused(false), []);
    
    return {
        isFocused,
        onFocus: handleFocus,
        onBlur: handleBlur
    };
};
